import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import GeneralTopSection from '~/features/general-participation/components/GeneralTopSection'
import PageTabs from '~/features/general-participation/components/PageTabs'
import TicketBox from '~/features/general-participation/components/TicketBox'
import useGeneralParticipationTab from '~/features/general-participation/hooks/useGeneralParticipationTab'
import { useGeneralParticipationInfo } from '~/features/general-participation/queries/general-participation'
import {
  GeneralParticipationTabs,
  type Shop,
} from '~/features/general-participation/types/general-participation'
import { useOngoingEvent } from '~/features/main/queries/useMainContents'
import CosplayInfo from '~/pages/general-participation/CosplayInfo'
import GeneralInfoIntroduction from '~/pages/general-participation/GeneralInfoIntroduction'
import FloatingButton from '~/shared/components/buttons/FloatingButton'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import useViewport from '~/shared/hooks/useViewport'
import useVisibility from '~/shared/hooks/useVisibility'
import theme from '~/shared/styles/theme'

function GeneralInfoPage() {
  const navigate = useNavigate()
  const viewport = useViewport()
  const { data, isLoading } = useGeneralParticipationInfo()
  const { data: ongoingEvent } = useOngoingEvent()
  const [isTicketBoxVisible, ticketBoxRef] = useVisibility(0)

  const { generalParticipationTab, setGeneralParticipationTab } =
    useGeneralParticipationTab()

  if (isLoading) return <LoadingScreen />

  const { event_info, shop_info } = data || ({} as Shop)

  const isMobile = viewport < theme.deviceSizes.medium

  const handleBuyButtonClick = () => {
    navigate('/general-participation/ticket')
  }

  return (
    <Wrapper>
      <GeneralTopSection ongoingEvent={ongoingEvent} data={event_info} />
      <PageTabs
        tabContents={[
          GeneralParticipationTabs.INFO,
          GeneralParticipationTabs.COSPLAYER,
        ]}
        selectedTab={generalParticipationTab}
        $size="md"
        setSelectTab={setGeneralParticipationTab}
      />
      <div ref={ticketBoxRef}>
        <TicketBox
          data={event_info}
          isOpen={true}
          ongoingEvent={ongoingEvent}
        />
      </div>
      {generalParticipationTab === GeneralParticipationTabs.INFO ? (
        <GeneralInfoIntroduction data={shop_info} />
      ) : generalParticipationTab === GeneralParticipationTabs.COSPLAYER ? (
        <CosplayInfo />
      ) : null}
      {isMobile && (
        <FloatingButton isVisible={!isTicketBoxVisible}>
          <Button onClick={handleBuyButtonClick}>티켓 구매하러 가기</Button>
        </FloatingButton>
      )}
    </Wrapper>
  )
}

export default GeneralInfoPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: ${theme.size.headerHeight}px;

  @media ${theme.device.large} {
    gap: 48px;
    padding: 0 60px;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: ${theme.size.mobileHeaderHeight}px;
    padding: 0 20px;
  }
`

const Button = styled.button`
  cursor: pointer;

  width: 100%;
  height: 58px;

  font-size: 24px;
  font-weight: 500;
  line-height: 33;
  line-height: 33px; /* 수정: line-height에 px 단위 추가 */
  color: white;

  background-color: #313634;
  border: none; /* 추가: 기본 테두리 제거 */
  border-radius: 54px;
`
